import { coreApi } from '@/services/network';
import { getProfile, FrontSessionBaseInfo } from '@/services/core/me/getProfile';
import { CoreMappingCode, CoreMappingLogCode, CoreResponseCode, CoreResponseErrorCode } from '@/utils/code-enums';

/* ##########################################
 * ############# 구글로그인 토큰발급 #############
 * ########################################## */


/* function interface */
export interface FunctionReq {
  redirectURL?: string
  code?: string
}

export interface FunctionRes {
  message: string         // 성공(SUCCESS)/비회원(REGISTER)/실패(FAIL)
  errorCode: string;
  errorMessage: string;
  email?: string
  ssoToken?: string
  accessToken?: string
  data?: FrontSessionBaseInfo | null | undefined
}


/* Api Interface */
interface ApiRes {
  status: number,
  data?: {
    email?: string
    ssoToken?: string
    accessToken?: string
    needVerification?: boolean
  }
  code: string
  message: string
}

export const googleOAuth = async (request: FunctionReq): Promise<FunctionRes> => {
  let endPoint = `${process.env.REACT_APP_CORE_SERVER}/${process.env.REACT_APP_CORE_VERSION}/auth/google`;
  const method = 'GET';

  endPoint += `?code=${encodeURIComponent(request.code!)}`;

  const res: ApiRes = await coreApi<{}, ApiRes>(endPoint, {}, method, null, null);

  let message = CoreMappingCode[res.code as CoreResponseCode] || 'FAIL';
  let errorCode = CoreMappingLogCode[res.code as CoreResponseErrorCode] || 'C9999';
  let errorMessage = 'Login failed.';

  let data: FrontSessionBaseInfo | null | undefined;

  if ((res.code === CoreResponseCode.LOGIN_SUCCESS || res.code === CoreResponseCode.USER_FOUND || res.code === CoreResponseCode.ALREADY_LOGIN) && res.data) {
    if (res.data.needVerification) {
      message = 'VERIFY';
    } else if (res.data.accessToken) {

      /* 회원 role 가져오기 */
      const funcRes = await getProfile({ accessToken: res.data.accessToken });

      if (funcRes.message === 'SUCCESS') {
        data = funcRes.data;
      }
      else if (funcRes.message === 'TIMEOUT') {
        message = 'TIMEOUT';
      }
      else {
        errorCode = funcRes.errorCode;
        errorMessage = funcRes.errorMessage;
        message = 'FAIL';
      }

    }
  }
  return {
    message,
    errorCode,
    errorMessage,
    accessToken: res.data?.accessToken,
    ssoToken: res.data?.ssoToken,
    email: res.data?.email,
    data: data
  };
};
